// Custom confirm dialog override for @rails/ujs (Rails 7)
// Overrides Rails.confirm to show a Bootstrap modal instead of native browser confirm()
Rails.confirm = function(message, element) {
  // If already confirmed, allow the action
  if (element.dataset.confirmed === "true") {
    delete element.dataset.confirmed;
    return true;
  }

  var title = element.getAttribute('data-title') || 'Confermi la cancellazione ?';
  var html = "<div id=\"custom_confirm_overlay\"></div>" +
  "<div id=\"custom_confirm\">" +
    "<div class=\"confirm-header\">" +
      "<a class=\"close confirm-close\">&times;</a>" +
      "<h4 class=\"header blue\">" + title + "</h4>" +
    "</div>" +
    "<div class=\"confirm-body\">" +
      "<div class=\"alert alert-info\">" + message + "</div>" +
    "</div>" +
    "<div class=\"confirm-footer\">" +
      "<a class=\"confirm-btn confirm-cancel\">Annulla</a> " +
      "<a class=\"confirm-btn confirm-btn-primary confirm-ok\">Conferma</a>" +
    "</div>" +
  "</div>";

  $('body').append(html);

  function closeConfirm() {
    $('#custom_confirm, #custom_confirm_overlay').remove();
  }

  $('#custom_confirm .confirm-ok').on('click', function() {
    closeConfirm();
    element.dataset.confirmed = "true";
    element.click();
  });

  $('#custom_confirm .confirm-cancel, #custom_confirm .confirm-close').on('click', closeConfirm);
  $('#custom_confirm_overlay').on('click', closeConfirm);

  return false;
};
